import { render, staticRenderFns } from "./logo-text.vue?vue&type=template&id=5d8d5ce4&scoped=true&"
import script from "./logo-text.vue?vue&type=script&lang=js&"
export * from "./logo-text.vue?vue&type=script&lang=js&"
import style0 from "./logo-text.vue?vue&type=style&index=0&id=5d8d5ce4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d5ce4",
  null
  
)

export default component.exports